import { render } from "./tag.vue?vue&type=template&id=0504abc3"
import script from "./tag.vue?vue&type=script&lang=js"
export * from "./tag.vue?vue&type=script&lang=js"

import "./tag.vue?vue&type=style&index=0&id=0504abc3&lang=scss"

import exportComponent from "/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__